import { SnackbarKey, useSnackbar } from 'notistack'
import React from 'react'
import {IconButton} from "@mui/material";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';

enum SnackbarMode {
    DEFAULT = 'customDefault',
    INFO = 'customInfo',
    SUCCESS = 'customSuccess',
    WARNING = 'customWarning',
    ERROR = 'customError'
}

interface UseGlobalSnackbar {
    showSnackbar: (message: string, mode: SnackbarMode) => void
}

const useGlobalSnackbar = (): UseGlobalSnackbar => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    const action = (snackbarID: SnackbarKey) => (
        <>
            <IconButton sx={{ color: 'white' }} onClick={() => closeSnackbar(snackbarID)}>
                <CloseSharpIcon />
            </IconButton>
        </>
    )

    const showSnackbar = (message: string, variant: SnackbarMode) => {
        enqueueSnackbar(message, {
            autoHideDuration: 4000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            variant: variant,
            action
        })
    }

    return {showSnackbar}
}

export { useGlobalSnackbar, SnackbarMode }